import type { Components } from '@mui/material/styles';

export default function MUIImageListItem(): Components['MuiImageListItem'] {
  return {};
}
